<template>
    <CallInPopup
        ref="callInPopupRef"
        :client="callInClient"
        :client_id="callInClient.client_id"
    />
</template>

<script>
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onChildChanged } from "firebase/database";
import {configActionTypes} from '@/store/modules/config';
import CallInPopup from '@/views/Admin/CallInPopup';
import {monitorActionTypes} from '@/store/modules/monitor';

export default {
  name: "FirebaseRealtimeDb",
  components: {
    CallInPopup,
  },
  data() {
    return {
      callInClient: {
        telephone:  '',
        lastname:   '',
        firstname:  '',
        middlename: '',
        client_id:null
      }
    }
  },
  mounted() {
    this.fetchFeed();

    // let deal = {}

    // deal.id =  "0f34387a-93eb-11ed-a063-60e32700ce56"
    // deal.stages = []
    // deal.stages.push("0f34387a-93eb-11ed-a063-60e32700ce56")

//let phone = '79152823199'

    //const FLASH_TIMEOUT = 26450;

 //setTimeout(() => {
// let link = document.createElement('a');
// link.href = '/create-client?deal='+deal.id+'&stage='+deal.stages[0].id+'&phone='+phone;
//                             link.target = '_blank';
//                             document.body.appendChild(link);
//                             link.click();
//                             link.remove();

// this.createDeal(phone) 

//            }, FLASH_TIMEOUT);

    document.addEventListener('visibilitychange', this.handleVisibility);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibility);
  },
  methods: {
    handleVisibility() {
      if (document.hidden) {
        console.log('Вкладка не активна');
      } else {

        console.log('Вкладка активна');
      }
    },
    createDeal(phone) {
      let type = 'Продажа'
  
      this.$store.dispatch(monitorActionTypes.getListDeal, {
        type
      })
          .then((response) => {
            if (response.monitor.length === 1) {
              //this.$router.push({ name: 'CreateClient', params: { deal: response.monitor[0], client_phone: phone } })

              if (document.hidden) {
                
              } else {
                let deal = response.monitor[0]
                
                let link = document.createElement('a');
                                        link.href = '/create-client?deal='+deal.id+'&stage='+deal.stages[0].id+'&phone='+phone;
                                        link.target = '_blank';
                                        document.body.appendChild(link);
                                        link.click();
                                        link.remove();

              }
            }
          });
    },
    fetchFeed() {
      this.$store.dispatch(configActionTypes.getConfig)
          .then((response) => {
            if (!response.error) {
              this.bindDbChanges(response.data);
            }
          });
    },
    bindDbChanges(config) {
      /*
      const firebaseConfig = {
        apiKey:            "AIzaSyBqcrGlKIpWwOGoIdhd1qnADqGHqj5NNTk",
        //authDomain:        "anatol-fitnessclever.firebaseapp.com",
        projectId:         "anatol-fitnessclever",
        //storageBucket:     "anat324115158014ol-fitnessclever.appspot.com",
        messagingSenderId: "324115158014",
        appId:             "1:324115158014:web:3d072863b0b892767866af"
      };
      */
      let firebaseConfig = config.firebaseConfig;

      const firebaseApp  = initializeApp(firebaseConfig);
      const database     = getDatabase(firebaseApp);
      const starCountRef = ref(database, config.firebaseDbPath);

      onChildChanged(starCountRef, (snapshot)=>{
        if (localStorage.getItem('fio')) {
          console.log(localStorage.getItem('fio'))
        } else {
          console.log('not logged')
        }
        let ms = Date.now() / 1000;
        let uis = snapshot.val();
        console.log('Firebase Realtime Database - value changed  ', uis, ms);
        this.callInClient.telephone = null;
        this.callInClient.lastname = null;
        this.callInClient.firstname = null;
        this.callInClient.middlename = null;
        this.callInClient.client_id = null;
        if (uis.call_in) {
          this.callInClient.telephone = uis.call_in.contact_info.contact_phone_number;
          if (uis.client_info) {
            this.callInClient.lastname   = uis.client_info.last_name;
            this.callInClient.firstname  = uis.client_info.first_name;
            this.callInClient.middlename = uis.client_info.middle_name;

            if(this.callInClient.telephone){
              this.callInClient.client_id = uis.client_info.client_id;
              if(this.$refs.callInPopupRef && this.$refs.callInPopupRef != 'undefined' && this.$refs.callInPopupRef != undefined){
                this.$refs.callInPopupRef.show();
              }
            }
          } else {
            if(this.callInClient.telephone){
              this.$refs.callInPopupRef.show();
            }
          }
       
          // if (uis.manager_to_answer) {
          //   let user_id_1c = localStorage.getItem('user_id_1c');
          //   if (!user_id_1c) {
          //     alert('Перезайдите в WEB панель чтобы в localStorage добавилось поле "user_id_1c"');
          //   }
          //   if (user_id_1c == uis.manager_to_answer.id) {
          //     // Показываем попап только менеджеру, с которым связан звонящий клиент
          //     this.$refs.callInPopupRef.show();
          //   }
          // } else {
            // Показываем попап всем менеджерам
            
          //}
        }
        if (uis && uis.call_end) {
          if(this.$refs.callInPopupRef && this.$refs.callInPopupRef != 'undefined' && this.$refs.callInPopupRef != undefined){
            this.$refs.callInPopupRef.hide();
          }
        }
        if (uis.call_start) {
           if (uis.manager_to_answer) {
            let user_id_1c = localStorage.getItem('user_id_1c');
            console.log(user_id_1c)
            // if (!user_id_1c) {
            //   alert('Перезайдите в WEB панель чтобы в localStorage добавилось поле "user_id_1c"');
            // }
            if (user_id_1c == uis.manager_to_answer.id) {
              // Показываем попап только менеджеру, с которым связан звонящий клиент
              //this.$refs.callInPopupRef.show();

              if(uis.client_id){
                if(this.$route.path !== '/card-potential-client'){
                  //this.$router.push({name: 'CardClientNew', params: {client_id: uis.client_id}});

                  //const FLASH_TIMEOUT = 3450;

                    //setTimeout(() => {

                      if (document.hidden) {
                
                      } else {

                              let link = document.createElement('a');
                                              link.href = '/card-potential-client?clientid='+uis.client_id;
                                              link.target = '_blank';
                                              document.body.appendChild(link);
                                              link.click();
                                              link.remove();

                      }
                    //}, FLASH_TIMEOUT);

      

                } else {
                  //this.$router.push({name: 'CardClientNewOt', params: {client_id: uis.client_id}});

                  if (document.hidden) {
                
                    } else {


                        let link = document.createElement('a');
                                            link.href = '/card-potential-client?clientid='+uis.client_id;
                                            link.target = '_blank';
                                            document.body.appendChild(link);
                                            link.click();
                                            link.remove();

                    }
                }
                
              } else {
                //this.$router.push({name: 'CreateClient', params: {client_phone: uis.call_start.contact_info.contact_phone_number}});
                this.createDeal(uis.call_start.contact_info.contact_phone_number)
              }

            } else{
              console.log('не наш клиент!')
              console.log(uis.manager_to_answer)
            }
          } else {
            //Показываем попап всем менеджерам
            
          }
          
          if(this.$refs.callInPopupRef && this.$refs.callInPopupRef != 'undefined' && this.$refs.callInPopupRef != undefined){
          this.$refs.callInPopupRef.hide();
          }
        }
      });
    }
  }
}

/*
getToken(messaging, {
  // <YOUR_PUBLIC_VAPID_KEY_HERE>
  // Projects settings > Cloud Messaging > Web Push certificates
  vapidKey: 'BD7I3AYBRXiR4R2gS2e6G69sXmog7EEPq9g1xOBw3-MOf3Lp5cy_a1B5or93vt4RnPKVHyZdSvTk9ybiBKUlpIE'
}).then((currentToken) => {
  if (currentToken) {
    console.log('Auth Token :-)!!!!');
    console.log(currentToken);

    //messaging.subscribeToTopic(currentToken, 'topic1');


    // cQu11eYqwvExgnVIpAclo4:APA91bE2KwwgWn9NyziSE1lUnXn5bVnAtxdxT7jW6nRDm_oDo1pRUXjSXsToFx3IZzOR9LnfsKAZ0IWJm-pd3BFOGaJfMJUQ8dHQvs6AwgFtuvqYfpL7WSBGsTLiYAHyT8K7bTttmv_G
    // Send the token to your server and update the UI if necessary
    // ...
  } else {
    // Show permission request UI
    console.log('No registration token available. Request permission to generate one.');
    // ...
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  // ...
});

//messaging.subscribeToTopic([], 'topic1').then((rrr) => {});

Notification.requestPermission().then((permission) => {
  if (permission === 'granted') {
    console.log('Notification permission granted.'); // ++
  }
});

onMessage(messaging, (payload) => {
  console.log('Message received... ', payload);
  // ...
});
*/
</script>